import { Stack } from "@mui/material";
import { FilesContextProvider } from "../../context/myFilesContext";
import UserFilesHeaderComponent from "../../components/panel/files-board/header/UserFilesHeader";
import FileDescriptionModal from "../../components/panel/files-board/modals/file-descption-modal/FileDescriptionModal";
import UploadNewFileModal from "../../components/panel/files-board/modals/upload-new-file-modal/UploadNewFileModal";
import UserFilesTableComponent from "../../components/panel/files-board/table/UserFilesTable";

export default function FilesPage() {
  return (
    <FilesContextProvider>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
      >
        <UserFilesHeaderComponent />
        <UserFilesTableComponent />
      </Stack>
      <UploadNewFileModal />
      <FileDescriptionModal />
    </FilesContextProvider>
  );
}
